import { ReactNode } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { BackHomeButton } from "@/components/BackHomeButton";
import { ScrollProgress } from "@/components/ScrollProgress";
import { CookieConsent } from "@/components/CookieConsent";
import { SkipNavigation } from "@/components/SkipNavigation";

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <SkipNavigation />
      <ScrollProgress />
      <Header />
      <main id="main-content" className="flex-1 pt-20" role="main" aria-label="Main content">
        {children}
      </main>
      <Footer />
      <BackHomeButton />
      <CookieConsent />
    </div>
  );
}
